//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import MutualForm from '@/views/HumanResource/HrMutual/MutualForm'

//
export default {
    path: 'mutual',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'mutual-form',
            component: MutualForm,
        },
    ],
    meta: {
        title: 'Mutual',
    },
}
